// extracted by mini-css-extract-plugin
export default {"outerWrapper":"payment_outerWrapper__Hax79","fadeIn":"payment_fadeIn__YTtmy","centerBox":"payment_centerBox__HSQ1X"};